// Shared page block names configuration
// This file contains only the block name constants to avoid React component imports
export const PAGE_BLOCK_NAMES = [
  'faq-block',
  'longterm-therapy-block',
  'customer-support-block',
  'featured-therapist-block',
  'image-block',
  'app-buttons-block',
  'promo-block',
  'puzzle-block',
  'pricing-block',
  'topics-block',
  'b2-b-block',
  'hedepy-promo-block',
  'reviews-block',
  'promo-plan-block',
  'headline-with-cta',
  'steps-block',
  'header-subpage-block',
  'icons-with-notes-block',
  'price-list-block',
  'how-it-works-block',
  'how-it-works-arrows-block',
  'rich-content-block',
  'form-block',
  'insurance-companies-block',
  'insurance-table-block',
  'therapist-list-block',
  'company-testimonials-block',
  'ab-test-block',
  'typeform-block',
  'voucher-form-block',
  'detailed-description-block',
  'matching-banner-block',
  'results-block',
  'chat-block',
  'boxes-block',
  'features-block',
  'table-block',
  'therapists-images-block',
  'tags-and-content-block',
  'checkmarks-block',
  'testimonials-list-block',
  'diagnosis-legacy-block',
  'content-promo-block',
  'article-category-teaser',
  'resources-carousel-block',
  'link-block',
  'case-study-list-block',
  'case-study-carousel-block',
  'grid-block',
  'pages-collection-block',
  'newsletter-block',
  'youtube-video-block',
  'services-list-block',
] as const

export type PageBlockName = (typeof PAGE_BLOCK_NAMES)[number]
